/** voiceEvents.ts — how the microphone hands a spoken command to the screen that can run it. */
import type { VoiceCommandId } from "@demandhub-cms/shared";

export const VOICE_COMMAND_EVENT = "cms:voice-command";

export interface VoiceCommandDetail {
  id: VoiceCommandId;
  /** A screen that ran the command sets this, so the microphone can tell "done" from "not available here". */
  handled: boolean;
}

/** Sends a command to whichever screen is listening; true when one ran it. */
export function dispatchVoiceCommand(id: VoiceCommandId): boolean {
  const detail: VoiceCommandDetail = { id, handled: false };
  window.dispatchEvent(new CustomEvent<VoiceCommandDetail>(VOICE_COMMAND_EVENT, { detail }));
  return detail.handled;
}
